<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <div style="margin-top:30px;">
            <form>
              <div class="form-group row">
                <label for="imgprog" class="col-sm-3 col-form-label aright">{{ $t('programmer') }}</label>
                <div class="col-sm-9">
                  <div class="prog_control" style="padding-top:8px;">
                      <input class="prog_state" type="image" src="https://img.intratone.info/icon/etat/1.png" name="imgprog" id="imgprog" onclick="Prog.information();" style="float:left; margin:0 5px; width:auto;">
                      <img style="float:left; margin:0 10px; width:auto; margin-left:10px; height:20px;" src="https://img.intratone.info/Images/Programmateur/kiprog.png" onclick="Prog.information();">
                      <div style="clear:both;"></div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="serialgrave" class="col-sm-3 col-form-label aright">{{ $t('serialKiBolt') }}</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control badgegrave" id="serialgrave" v-model="serial" name="serialgrave">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label aright"></label>
                <div class="col-sm-6">
                  <div v-if="serial=='' && error==''" class="alert alert-info" style="text-align:center; margin: 20px auto;">
                    {{ $t('putKiBoltInProg') }}
                  </div>
                  <div v-if="error!=''" class="alert alert-danger" style="width: 80%; margin: 20px auto;">
                    {{ error }}
                  </div>
                </div>
              </div>
              <div  v-if="serial!='' && loading==''" class="form-group row">
                <label class="col-sm-3 col-form-label aright"></label>
                <div class="col-sm-6">
                  <a class="linkDwn" v-on:click="writeSoftKiBolt">Mettre à jour une clé</a>
                </div>
              </div>
              <div v-if="loading!=''" class="form-group row">
                <label class="col-sm-3 col-form-label aright">
                </label>
                <div class="col-sm-6">
                  <table>
                    <tr>
                      <td>
                        <radial-progress-bar :diameter="80"
                                              :completed-steps="completedSteps"
                                              :total-steps="totalSteps"
                                              :animate-speed="animateSpeed"
                                              :fps="fps">
                          {{ completedSteps }} %
                        </radial-progress-bar>
                      </td>
                      <td>
                        <div style="margin-top:20px;" class="alert alert-secondary">
                          Chargement de la clé, veuillez patienter,<br/>temps estimé de 1m20s                
                        </div>
                      </td>
                    </tr>
                  </table>          
                </div>
              </div>
            </form>
            <!--
            <div v-if="loading!=''" style="width: 80%; margin: 20px auto;">
              <div class="alert alert-secondary">
                Chargement de la clé, veuillez patienter, temps estimé de 1m20s                
              </div>
              <center>
                <div>
                  <radial-progress-bar :diameter="100"
                                        :completed-steps="completedSteps"
                                        :total-steps="totalSteps"
                                        :animate-speed="animateSpeed"
                                        :fps="fps">
                    {{ completedSteps }} %
                    </radial-progress-bar>
                </div>
              </center>
            </div>
            -->
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'
/*import VueCircle from 'vue2-circle-progress'*/
import RadialProgressBar from 'vue-radial-progress'

export default {
  name: 'Badge',
  components: {
      TopBar,
      MenuSetup,
      RadialProgressBar
  },
  data: function() {
    return {
      completedSteps: 0,
      animateSpeed:1000,
      totalSteps: 100,
      fps:60,
      fill : { gradient: ["red", "green", "blue"] },
      system : false,
      nav : false,
      appli : '',
      prog : false,
      serial: '',
      color : '',
      error : '',
      loading : '',
      //url : 'https://apiload-test.kibolt.info'
      url : 'https://apiload.kibolt.info'
    }
  },  
  created: function () {
    document.title = this.$i18n.t(`readAnKiBolt`);
    let self = this;
    setTimeout(function(){
      self.runReadBadge();
    },300);
  },
  beforeDestroy(){
    Prog.close();
  },
  methods : {
    progress(event,progress,stepValue){
        console.log(stepValue);
    },
    progress_end(event){
      console.log("Circle progress end");
    },    
    runReadBadge(){
      self = this;
      Prog.install();
      Prog.init(function (d) {
          self.readAnKiBolt();
      }, null, 0, true);
    },
    readAnKiBolt(){
      self = this;
      self.serial = '';
      self.loading='';
      Prog.request({"function":"kbtReadKibolt", "url":this.url}, function (data) {
        self.error = '';
        self.serial = data.serial;
        self.color = data.color;
        /*
          self.serial = data.serial;
          self.session = data.session;
          self.color = data.color;
          self.type = data.type;
        */
      });
    },
    completeTimer(){
      //self.completedSteps = 99;
      var self = this; 
      if (self.completedSteps==0){
        return false;
      }
      self.completedSteps++;
      if (self.completedSteps==99){
        return false;
      }
      setTimeout(function(){
        self.completeTimer();
      },1000);
    },
    writeSoftKiBolt(){      
      var self = this;  
      let json = {"function":"kbtSoftWrite", "url":this.url};
      self.loading = 'start';
      self.completedSteps=1;
      self.completeTimer();
      Prog.request(json, function (data) {
        console.log('writeSoftKiBolt');
        console.log('writeSoftKiBolt', data);
        if (data.error && data.error>0){
          //self.error = "Une erreur est survenue lors du chargement des données de la clé";
          alert("Une erreur est survenue lors du chargement des données de la clé");
        }else{
          alert("Votre clé KiBolt est maintenant à jour");
        } 
        self.readAnKiBolt();       
        self.completedSteps=0;
        /*setTimeout(function(){          
        },2000);*/
      });
    },
    writeKiBoltKey(){
      var self = this;      
      let json = {"function":"kbtWriteKiboltData", "url":this.url, "serial":self.serial};
      //let json = {"function":"kbtWriteKiboltData", "url":"http://apiload-dev.kibolt.info:6101"};
      self.loading = 'start';
      self.completedSteps=1;
      self.completeTimer();
      Prog.request(json, function (data) {
        console.log('writeKiBoltKey');
        console.log('writeKiBoltKey', data);
        if (data.error && data.error>0){
          //self.error = "Une erreur est survenue lors du chargement des données de la clé";
          alert("Une erreur est survenue lors du chargement des données de la clé");
        }else{
          alert("Votre clé KiBolt est maintenant à jour");
        }        
        self.completedSteps=0;
        setTimeout(function(){
          self.readAnKiBolt();
        },2000);        
      });
    },

  }
}
</script>
<style scoped>
.aright {
    text-align: right;
}
.steps {
  text-align: left;
  margin:30px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}
.bimg {
  height: 50px;
}
a:hover h3 {
  color: #043967;
}
.step {
  margin:10px 20px;
}
.stepi {
  height: 24px;
}
a.act {
    margin: 10px auto;
    width: auto;
    padding: 10px;
    display: block;
    color : grey;
    background: #f8f8f8;
    border-radius: 10px;
    text-align: center;
    text-decoration: none;
}
a.act:hover {
    background: #eee;
    color : #08c;
    text-decoration: none;
}
a.act span {
    display: block;
}
a.act img {
    height: 50px;
}
a.linkDwn {
    margin: 20px;
    width: auto;
    font-size: 16px;
    padding: 15px 30px;
    margin-bottom: 20px;
    /*display: block;*/
    background: #f2f2f2;
    border-radius: 10px;
    text-align: left;
    color:#222!important;
    text-decoration: none;
}
a.linkDwn:hover {
    /*background: #aaa;*/
    background: #0f66aa;
    color:#fff!important;
    text-decoration: none;
}
a.linkDwn span {
    display: block;
}
</style>
